import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    display: 'block',
    width: 28,
    height: 28,
    objectFit: 'contain',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src="va-logo.png" alt="VA" />;
};

export default LogoIcon;
